import React from 'react'
import classNames from 'classnames'
import PageContentTabs from '../../PageContent/components/PageContentTabs'
import { CloseIcon } from '../../../images/common'
import './SlidePanelHeader.scss'

const SlidePanelHeader = ({ headerProps, onClose, color, isFullscreen, setIsFullscreen, onFullscreen }) => {
  const { icon, title, tabs, customAction } = headerProps

  return (
    <div
      className={classNames(
        'viso-slide-panel-header',
        tabs && 'viso-slide-panel-header--tabs',
        isFullscreen && 'viso-slide-panel-header--fullscreen'
      )}
    >
      <div className={classNames('viso-slide-panel-header__top viso-text-label', isFullscreen && 'viso-slide-panel-header__top--fullscreen')}>
        {icon &&
          <div className={classNames('viso-slide-panel-header__icon', isFullscreen && 'viso-slide-panel-header__icon--fullscreen')}>
            {icon}
          </div>
        }
        <div className={classNames('viso-slide-panel-header__title', isFullscreen && 'viso-slide-panel-header__title--fullscreen')}>
          {title}
        </div>
        <button
          className={classNames('viso-slide-panel-header__close viso-text-label', isFullscreen && 'viso-slide-panel-header__close--fullscreen')}
          type='button'
          onClick={() => {
            if (isFullscreen) {
              setIsFullscreen(false)
              onFullscreen && onFullscreen(false)
            } else {
              onClose()
            }
          }}>
          <CloseIcon />
          {isFullscreen && <span className='viso-slide-panel-header__close__label'>Close</span>}
        </button>
      </div>
      {(tabs || customAction) &&
        <div className={classNames('viso-slide-panel-header__tabs', isFullscreen && 'viso-slide-panel-header__tabs--fullscreen')}>
          {tabs &&
            <PageContentTabs
              color={color}
              tabs={tabs}
              noMargin
            />
          }
          {customAction}
        </div>
      }
    </div>
  )
}

export default SlidePanelHeader